import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-continue",
  "use": "app-icon-continue-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"app-icon-continue\"><path fill=\"#5B7EDE\" d=\"M0 .6l7.2 6-7.2 6z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol